import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const VentilationOffFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M17.9315 7.1504L22.0455 3.03646L20.7727 1.76367L15.6099 6.92641C14.4722 7.03007 13.5791 7.43301 12.8999 7.99857V2.69991H11.9999C11.1559 2.69991 9.90989 2.94571 8.84903 3.70952C7.74228 4.50638 6.8999 5.82658 6.8999 7.7999C6.8999 9.22361 7.33839 10.3074 7.99828 11.0999L2.69991 11.0999V11.9999C2.69991 12.8439 2.94571 14.0899 3.70952 15.1507C4.19627 15.8268 4.87828 16.4042 5.78514 16.7512L1.69751 20.8388L2.9703 22.1116L7.98455 17.0974C7.9885 17.0973 7.99244 17.0971 7.99638 17.097L17.9403 7.15315C17.9374 7.15223 17.9344 7.15131 17.9315 7.1504ZM11.0999 16.5391L19.5758 8.0632C19.8495 8.3016 20.0869 8.56683 20.2903 8.84927C21.0541 9.91013 21.2999 11.1561 21.2999 12.0001V12.9001H16.0015C16.6614 13.6927 17.0999 14.7764 17.0999 16.2001C17.0999 18.1734 16.2575 19.4936 15.1508 20.2905C14.0899 21.0543 12.8439 21.3001 11.9999 21.3001H11.0999L11.0999 16.5391Z"
      />
    </SvgIcon>
  );
});
